<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1 class="display-3  text-white">Robotics
                                </h1>
                                <p class="lead  text-white">
                                    Intelligent robots are machine systems that fully simulate humans in terms of perception, thinking, and effects. In recent years, with the development and breakthrough of AI, big data, and intelligent manufacturing, the experience of using robots has been further improved. In addition, the integration of technologies such as voice interaction, face recognition, and automatic positioning and navigation with robots has continued to deepen. It has become more abundant and has a wide range of applications in different fields.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        
        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="/img/autonomous_navigation.jpg" class="img-fluid">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <h3 class="text-white">Autonomous navigation</h3>
                            <p class="text-white">Autonomous navigation technology is the first step to realize the intelligent walking of robots. In essence, it helps robots realize autonomous positioning, mapping, path planning, and obstacle avoidance capabilities. With the help of eyes (such as lidar) to help the robot complete the scanning of the surrounding environment, cooperate with the corresponding algorithm to construct effective map data, complete the calculation, and realize the robot's autonomous positioning and navigation.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img src="/img/intelligent_automation.jpg" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <h3 class="text-white">Intelligent automation</h3>
                            <p class="text-white">Intelligent automation combines the task execution of RPA with the machine learning and analysis capabilities of automatic process discovery and process analysis, as well as cognitive technologies such as computer vision, natural language processing and fuzzy logic, and expands the vision of business process automation by an order of magnitude. Intelligent automation covers the entire automation process from discovery, automation to optimization, automates any front-end or back-end business process, and coordinates work between human and robot teams.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="/img/scene_reconstruction.jpg" class="img-fluid">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <h3 class="text-white">Scene Reconstruction</h3>
                            <p class="text-white">Reconstruct the scene or draw a three-dimensional map, so that the robot can perceive its position in the space in real time, so as to avoid obstacles in time when moving. This requires generating depth images based on depth information, and fusing them with RGB images, even infrared images, and completing a lot of calculations. However, the depth images generated by hardware-perceived information often have defects caused by hardware performance limitations. All these need to rely on artificial intelligence algorithms for real-time processing to compensate and enhance</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "autonomous-driving",
  components: {
      
  }
};
</script>